<mat-icon class="{{ isTrue ? 'status-true' : 'status-false' }}">{{ isTrue ? 'done' : 'close' }}</mat-icon>
